module.exports = __webpack_public_path__ + "static/media/close_down.3ce8afe9.png";